<template>
	<div class="flex place-items-center p-2" v-if="loading">
		<app-icon :class="`icon-spin-loading ${size === 'sm' ? 'text-lg' : 'text-5xl'}`" />
	</div>
	<div
		v-else
		:class="[
			'flex items-center justify-center border-1 border-border-color',
			['PENDING', 'REJECTED', 'DELIVERED', 'ACCEPTED'].includes(status) || isTakeaway ? icon.container : '',
			[
				size === 'sm' ? 'rounded-sm w-8 h-8' : 'rounded-lg w-20 h-20',
				icon.emits ? 'cursor-pointer' : 'cursor-default',
			],
		]"
		@click.stop="onIconClick"
	>
		<app-icon
			v-if="
				enableCookingTimeProp
					? iconStatusesNew.includes(status) || isTakeaway
					: iconStatuses.includes(status) || isTakeaway
			"
			:class="['text-white', [loading ? 'icon-spin-loading' : icon.content], [size === 'sm' ? '' : 'text-5xl']]"
		/>
		<Vue3Lottie v-else :animationData="chosenAnimation" :loop="true" :scale="1.5" :autoPlay="true" />
	</div>
</template>

<script>
	import { statuses } from '@/constants/mapOrderStatuses';
	import { Vue3Lottie } from 'vue3-lottie';
	import preparing from '@/assets/animations/preparing.json';
	import delivered from '@/assets/animations/delivered-takeaway.json';
	import chefCooking from '@/assets/animations/chefcooking.json';
	import onTheWay from '@/assets/animations/scooterontheway.json';
	import { mapGetters } from 'vuex';

	const getStyle = (content = '', container = '', emits = null) => ({
		content,
		container,
		emits,
	});

	export default {
		name: 'OrderStatusIcon',
		emits: ['answer', 'cookOrder', 'deliverOrder'],
		components: { Vue3Lottie },
		data() {
			return {
				preparing,
				delivered,
				chefCooking,
				onTheWay,
				iconStatuses: ['PENDING', 'REJECTED', 'DELIVERED', 'ACCEPTED'],
				iconStatusesNew: ['PENDING', 'REJECTED', 'DELIVERED'],
			};
		},
		props: {
			status: {
				type: String,
				required: true,
			},
			isTakeaway: {
				type: Boolean,
				default: false,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			size: {
				type: String,
				default: 'md',
			},
			enableCookingTimeProp: {
				default: 0,
			},
		},
		computed: {
			...mapGetters({
				posSettings: 'posSettings',
			}),
			chosenAnimation() {
				if (this.enableCookingTimeProp) {
					if (this.status === statuses.accepted || this.status === statuses.pickedUp) {
						return chefCooking;
					} else if (this.status === statuses.collected) {
						return onTheWay;
					} else return delivered;
				} else {
					if (this.status === statuses.cooked || this.status === statuses.inRestaurant) {
						return chefCooking;
					} else if (this.status === statuses.pickedUp || this.status === statuses.collected) {
						return onTheWay;
					} else return delivered;
				}
			},
			icon() {
				let style = this.enableCookingTimeProp ? 'cursor-pointer' : 'bg-success cursor-pointer'; //remove after
				if (this.status === statuses.pending) {
					return getStyle('icon-bell bell', 'bg-primary cursor-pointer', 'answer');
				} else if (this.status === statuses.delivered) {
					return getStyle('icon-save', 'bg-success');
				} else if (this.status === statuses.rejected) {
					return getStyle('icon-deny', 'bg-primary');
				} else if (this.status === statuses.accepted) {
					return this.isTakeaway
						? getStyle('icon-greeting', 'bg-warning cursor-pointer', 'cookOrder')
						: getStyle('icon-bike', style, 'cookOrder');
				} else if (this.status === statuses.pickedUp && this.enableCookingTimeProp) {
					return getStyle('icon-bike', 'cursor-pointer', 'cookOrder');
				} else if (this.isTakeaway) {
					return getStyle('icon-save', 'bg-warning cursor-pointer', 'deliverOrder');
				} else {
					return getStyle();
				}
			},
		},
		methods: {
			onIconClick() {
				if (this.icon.emits) {
					this.$emit(this.icon.emits);
				}
			},
		},
	};
</script>

<style scoped></style>
